export const updateOrderFormField = (field, value) => ({
  type: 'ORDER_FORM_UPDATE_FIELD',
  payload: { field, value }
});

export const setOrderFormError = (field, error) => ({
  type: 'ORDER_FORM_SET_ERROR',
  payload: { field, error }
});

export const clearOrderFormError = (field) => ({
  type: 'ORDER_FORM_CLEAR_ERROR',
  payload: { field }
});

export const setDeliveryLocation = (location, coords) => ({
  type: 'ORDER_FORM_SET_DELIVERY_LOCATION',
  payload: { location, coords }
});

export const setDeliveryDistance = (distance) => ({
  type: 'ORDER_FORM_SET_DELIVERY_DISTANCE',
  payload: { distance }
});

export const setOrderFormStep = (step) => ({
  type: 'ORDER_FORM_SET_STEP',
  payload: { step }
});

export const toggleOrderFormModal = (modalName, value) => ({
  type: 'ORDER_FORM_TOGGLE_MODAL',
  payload: { modalName, value }
});

export const setOrderFormLoading = (loading) => ({
  type: 'ORDER_FORM_SET_LOADING',
  payload: loading
});

export const resetOrderForm = () => ({
  type: 'ORDER_FORM_RESET'
});

// Action to trigger reverse geocoding saga
export const reverseGeocodeLocation = (lat, lng) => ({
  type: 'REVERSE_GEOCODE',
  payload: { lat, lng }
});

// Action to trigger location search saga
export const searchLocation = (query) => ({
  type: 'LOCATION_SEARCH',
  payload: { query }
});
